import { render, staticRenderFns } from "./AdditionalForms.vue?vue&type=template&id=de3b19fc&scoped=true"
import script from "./AdditionalForms.vue?vue&type=script&lang=ts"
export * from "./AdditionalForms.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalForms.vue?vue&type=style&index=0&id=de3b19fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3b19fc",
  null
  
)

export default component.exports